import { isAuthorized } from '@zg-rentals/auth-comet';
import { defineAuthProvider } from '@zg-rentals/auth-react/legacy';
import { RentalManagerUserInfoV2WebApiHandler_get_queryOptions } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { client as zgApiClient } from '../../http/zgApiClient';

const client = zgApiClient.extend({ timeout: 10_000 });

export const Auth = defineAuthProvider({
  queryOptions: () =>
    RentalManagerUserInfoV2WebApiHandler_get_queryOptions(
      {
        includeCanClaimFreeListings: true,
        includeCustomers: true,
        includeProfileImageUrl: true,
      },
      { httpClient: client },
    ),
  isAuthorized: isAuthorized({
    mapUser: (user) => ({ ...user, isLoggedIn: user.loggedIn }),
  }),
});

export const { useAuth } = Auth;
